module.exports = __webpack_public_path__ + "static/img/szmjyy.84e1f9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/szmjyy.png
// module id = +joN
// module chunks = 0